import { css } from 'lit';

export const styles = css`:host{padding:1rem}`;
